import React, { useRef, useState, useEffect } from 'react';
import { Button, Tooltip, Typography, Box } from '@mui/material';

const ResponsiveButton = ({
  label,
  type = 'text', // 'text' | 'logo'
  logoSrc,
  alt,
  href,
  target,
  onClick,
  logoSx = {},
}) => {
  const textRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    if (type !== 'text') return;

    const el = textRef.current;
    if (!el) return;

    const check = () => setIsTruncated(el.scrollWidth > el.clientWidth);
    check();

    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, [label, type]);

  let content = null;

  if (type === 'logo') {
    content = (
      <Box
        component="img"
        src={logoSrc}
        alt={alt}
        sx={{
          ...logoSx,
        }}
      />
    );
  }

  if (type === 'text') {
    content = (
      <Typography
        ref={textRef}
        noWrap
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          width: '100%',
          color: 'black',
          fontSize: 16,
          fontWeight: 600,
          fontFamily: theme => theme.typography.fontFamily,
          lineHeight: 1.4,
        }}
      >
        {label}
      </Typography>
    );
  }

  const button = (
    <Button
      onClick={onClick}
      href={href}
      target={target}
      sx={{
        flexGrow: 0,
        flexShrink: 1,
        flexBasis: 'auto',
        minWidth: 0,
        maxWidth: '100%',
        paddingX: type === 'logo' ? 1 : 1.5,
        color: 'black',
        textTransform: 'none',
        justifyContent: 'center',
        display: { xs: 'none', lg: 'block' },
      }}
    >
      {content}
    </Button>
  );

  if (type === 'text' && isTruncated) {
    return (
      <Tooltip title={label} arrow>
        {button}
      </Tooltip>
    );
  }

  return button;
};

export default ResponsiveButton;
